import Fab from '@mui/material/Fab'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import HelpIcon from '@mui/icons-material/Help'
import { useTranslation } from 'react-i18next'
import { getButtonTestId } from '../Buttons/getButtonTestId'

/** @notExported */
interface HelpButtonProps {
  /* Action to perform on click */
  onChange: (open: boolean) => void
  /** Test id of the button. */
  testId?: string
}

/**
 * Edit button component.
 *
 * @returns Edit button.
 * @notExported
 * @category Buttons
 */
const HelpButton: React.FC<HelpButtonProps> = ({ onChange, testId }) => {
  const { t } = useTranslation()
  const resolvedTestId = getButtonTestId({ fallback: 'button-help-fab', label: t('help'), testId })

  return (
    <Tooltip title={t('help')}>
      <Fab
        data-testid={resolvedTestId}
        color="primary"
        aria-label={t('help')}
        size="medium"
        onClick={() => {
          onChange(true)
        }}
        sx={{ position: 'fixed', bottom: 50, right: 50, zIndex: 9998 }}
      >
        <HelpIcon />
      </Fab>
    </Tooltip>
  )
}

export default HelpButton
